$(function () {
    $("#ac_itemDetail").click(function () {
        $("#outputItemDetail").slideToggle();
        $('#ac_itemDetail .circle-plus').toggleClass('opened');
    });
});
$(function () {
    $("#ac_attention").click(function () {
        $("#outputAttention").slideToggle();
        $('#ac_attention .circle-plus').toggleClass('opened');
    });
});
$(function () {
    $("#ac_coupon").click(function () {
        $("#outputCoupon").slideToggle();
        $('#ac_coupon .circle-plus').toggleClass('opened');
    });
});
$(function() {
$("#ac_review").click(function() {
$("#outputReview").slideToggle();
$('#ac_review .circle-plus').toggleClass('opened');
});
});
$(function () {
    $("#ac_influencer").click(function () {
        $("#outputInfluencer").slideToggle();
        $('#ac_influencer .circle-plus').toggleClass('opened');
    });
});
$(function() {
$("#ac_item_image").click(function() {
$("#outputItemImage").slideToggle();
$('#ac_item_image .circle-plus').toggleClass('opened');
});
});